import type { ReactElement } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'components/shared/Modal';

type Props = {
  show: boolean;
  onClose: () => void;
  contentType: 'on-demand' | 'weekly';
};

const contentText = {
  weekly: {
    text: 'Your weekly subscription is active. You’ll start receiving your meal deliveries on the estimated date.',
    subText: 'We\'re committed to making your meal kit experience as convenient and stress-free as possible. So sit back and enjoy delicious, chef-crafted meals delivered straight to your doorstep on your own schedule.',
  },
  'on-demand': {
    text: 'You’ll be receiving just this box, as requested.',
    subText: 'We\'re committed to making your meal kit experience as convenient and stress-free as possible. So sit back and enjoy delicious, chef-crafted meals delivered straight to your doorstep on your own schedule.',
  },
};

function ThankYouModal({ show, onClose, contentType }: Props): ReactElement {
  return (
    <Modal
      show={show}
      onClose={onClose}
      className="c-modal-auto-skip-thank-you"
      header={<Modal.Header>Thank you!</Modal.Header>}
      body={(
        <div className="c-modal-auto-skip-thank-you__content">
          <strong>
            {contentText[contentType].text}
          </strong>
          <br />
          <br />
          {contentText[contentType].subText}
        </div>
      )}
      footer={(
        <Button
          className="c-button c-button--primary"
          onClick={onClose}
        >
          Got It
        </Button>
      )}
    />
  );
}

export default ThankYouModal;
